import PropTypes from "prop-types"
import React from "react"

import Guides from "@svgs/contact/guides.svg"
import Delivery from "@svgs/contact/delivery.svg"
import SpareParts from "@svgs/contact/spare-parts.svg"
import RichText from "@components/rich-text"
import Link from "./link"

const points = [
  {
    title: 'Guides and Manuals',
    text: 'How to get the most from your Diggs.',
    icon: Guides,
    alt: 'Books icon',
    linkText: 'See all guides and manuals',
    linkTo: '/resources/manuals/',
  },
  {
    title: 'Delivery & Returns',
    text: 'View delivery and returns info.',
    icon: Delivery,
    alt: 'Truck icon',
    linkText: 'See our return policy',
    linkTo: '/faq-and-returns/',
  },
  {
    title: 'Spare Parts',
    text: 'Just in case your Diggs needs it.',
    icon: SpareParts,
    alt: 'Cog icon',
    linkText: 'Buy replacement parts',
    linkUrl: '#contact-form',
  },
]

const SupportPoints = () => (
  <div className="bg-white w-full flex justify-center">
    <div className="w-full max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="grid sm:grid-cols-12 sm:gap-12">
        {points.map((point, index) => <Point key={`supportPoint-${index}`} {...point} />)}
      </div>
    </div>
  </div>
)

const Point = ({ title, text, linkText, linkUrl, linkTo, icon, alt }) => (
  <div className="col-span-4 text-center">
    <div className="w-full max-w-screen-xl mx-auto py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      {icon && <img src={icon} alt={alt} className="mb-4 mx-auto" />}
      <h2 className="mb-2">{title}</h2>
      <RichText className="mb-4">{text}</RichText>

      {(linkTo || linkUrl) && (
        <Link href={linkTo || linkUrl} title={title}>
          {linkText}
        </Link>
      )}
    </div>
  </div>
)


SupportPoints.propTypes = {
  siteTitle: PropTypes.string,
}

export default SupportPoints
